// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GQp2Z","containerMax":"styles_containerMax__AUdYm","title":"styles_title__CMzde"};